// Module
var code = "<div :title=\"name\" class=\"c-avatar\" :style=\"{ 'background': (imageUrl ? 'url(' + imageUrl + ')' : backgroundColor) + ' no-repeat center /cover' }\" data-axe-ignore> <span class=\"initials\">{{ imageUrl == null ? initials : '&nbsp;' }}</span> </div> ";
// Exports
export default code;